import { debounce, each, range, throttle } from "lodash";
import { fillContainer } from "./utils/layout";
import { onSmallScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;

const $window = $(window);
const dfTransitionDuration = 0.5; // seconds
const dfWaitDuration = 5; // seconds

export function initItemSliders(): void
{
	$(".item-slider").each(function () {
		const $outerWrap = $(this);
		initItemSlider($outerWrap);
	});
}

function getTransitionDuration($outerWrap): number
{
	const n: number = parseInt($outerWrap.attr("data-transition-duration"), 10);
	return (n || dfTransitionDuration) * 1000;
}

function getWaitDuration($outerWrap): number
{
	const n: number = parseInt($outerWrap.attr("data-transition-wait"), 10);
	if (n === 0)
	{
		return 0;
	}
	return (n || dfWaitDuration) * 1000;
}

function populateRemainingItems($itemsInnerWrap, $origItems, maxNumOnScreen: number): void
{
	const origItemsLength: number = $origItems.length;
	let numItems: number = origItemsLength;
	while (numItems < maxNumOnScreen * 2)
	{
		$origItems.each(function () {
			$itemsInnerWrap.append($(this).clone());
			++numItems;
		});
	}
	// move last item to start
	//$itemsInnerWrap.prepend($itemsInnerWrap.find(".item-slider-item").last());
}

function initItemSlider($outerWrap): void
{
	const $itemsOuterWrap = $outerWrap.find(".item-slider-items");
	const $itemsInnerWrap = $itemsOuterWrap.children();
	const $origItems = $itemsInnerWrap.find(".item-slider-item");
	let index: number = $origItems.length;
	
	const transitionDuration: number = getTransitionDuration($outerWrap);
	const waitDuration: number = getWaitDuration($outerWrap);
	const maxNumOnScreen: number = parseInt($outerWrap.attr("data-max-num-onscreen"), 10);
	const numOnScreenLg: number = parseInt($outerWrap.attr("data-num-onscreen-lg"), 10);
	const numOnScreenSm: number = parseInt($outerWrap.attr("data-num-onscreen-sm"), 10);

	let timer: any;
	let notifyOfMove: (newIndex: number) => void = undefined;
	let transitioning = false;

	populateRemainingItems($itemsInnerWrap, $origItems, maxNumOnScreen);

	const getItems = () => $itemsInnerWrap.find(".item-slider-item");
	const numItems: number = getItems().length;
	const getNumItemsOnScreen = (): number => onSmallScreen() ? numOnScreenSm : numOnScreenLg;

	const fixLayout = function fixLayout(): void {
		clearTimeout(timer);
		const $items = getItems();
		const numItemsOnScreen: number = getNumItemsOnScreen();
		const itemWidth: number = $itemsOuterWrap.outerWidth() / numItemsOnScreen;
		const innerWrapWidth: number = itemWidth * numItems;
		$items.css({ width: itemWidth });
		$itemsInnerWrap.css({ width: innerWrapWidth });
		let x = -itemWidth;
		$items.addClass("disable-anim").each(function () {
			$(this).css({ left: x });
			x += itemWidth;
		}).removeClass("disable-anim");
	};

	fixLayout();
	$(fixLayout);
	$window.on("resize load", debounce(fixLayout, 100)); // fixme orientationchange?

	const waitThenNext = function waitThenNext(): void {
		clearTimeout(timer);
		if (waitDuration > 0)
		{
			timer = setTimeout(next, waitDuration);
		}
	};

	const move = function move(directionSym: "+"|"-"): void {
		if (transitioning)
		{
			return;
		}
		clearTimeout(timer);
		transitioning = true;
		const $items = getItems().stop(true);
		const afterAnim = () => {
			transitioning = false;
			waitThenNext();
		};
		const $firstItem = $items.first();
		const $lastItem = $items.last();
		const itemWidth: number = $firstItem.outerWidth(true);

		switch (directionSym)
		{
			case "+":
				// anim left; put first item in set at end of items
				$itemsInnerWrap.append($firstItem);
				$firstItem.css({ left: $lastItem.position().left + itemWidth });
				$items.each(function () {
					const $item = $(this);
					$item.animate({ left: $item.position().left - itemWidth }, transitionDuration);
				});
				break;

			case "-":
				// anim right; put last item in set at start of items
				$itemsInnerWrap.prepend($lastItem);
				$lastItem.css({ left: $firstItem.position().left - itemWidth });
				$items.each(function () {
					const $item = $(this);
					$item.animate({ left: $item.position().left + itemWidth }, transitionDuration);
				});
				break;
		}

		timer = setTimeout(afterAnim, transitionDuration + 50);
	};

	const next = function next(): void {
		move("+");
	};

	const prev = function prev(): void {
		move("-");
	};

	setupControls($outerWrap, prev, next);

	waitThenNext();
}

function setupControls(
	$outerWrap,
	prev: () => void,
	next: () => void)
{
	const $chevrons = $outerWrap.find(".item-slider-chevron");
	if ($chevrons.length > 0)
	{
		setupChevrons($chevrons, prev, next);
	}
}

function setupChevrons($chevrons, prev: () => void, next: () => void): void
{
	$chevrons.filter(".item-slider-chevron-prev").click((ev) => prev());
	$chevrons.filter(".item-slider-chevron-next").click((ev) => next());
}
